import { Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import customerImg from '../../assets/images/CustomerManagement/customer-img.svg'
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadUserCustomFieldData } from "../../redux/action";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const approvalTypeOptionsOption = [
    { value: 1, label: "Level 1" },
    { value: 2, label: "Level 2" },
    { value: 3, label: "Level 3" },
    { value: 4, label: "Level 4" },
    { value: 5, label: "Level 5" },
]

const ViewUserModal = (props) => {

    const singleUserData = props.singleUserData;
    const setLoading = props.setLoading;
    const customFields = props.customFields;
    const userID = props.userID;
    const dataLoading = props.dataLoading;

    const dispatch = useDispatch();
    const { getUserCustomFieldData } = useSelector((state) => state.data);
    console.log(getUserCustomFieldData, 'getUserCustomFieldData')

    useEffect(() => {
        dispatch(loadUserCustomFieldData(setLoading, customFields, userID))
    }, [])

    const renderTextWithTooltip = (text) => {
        // Check if the text length exceeds 24 characters
        if (text && text.length > 24) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{text}</Tooltip>}
                >
                    <span>{text.substring(0, 24)}...</span>
                </OverlayTrigger>
            );
        }
        return <span>{text}</span>;
    };
    return (
        <>
            <Modal show={props.viewModal} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal' >
                <Modal.Header closeButton>
                    <Modal.Title>View User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col className='customer-form-fields-image-div'>
                            <img src={singleUserData[0]?.FilePath
                                ? singleUserData[0]?.FilePath.includes('http')
                                    ? singleUserData[0]?.FilePath
                                    : `data:image/png;base64,${singleUserData[0]?.FilePath}`
                                : customerImg} alt="" style={{ height: "100px", width: "100px" }} />
                            <input type="file" hidden />
                            <p>Upload Image</p>
                        </Col>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>First Name</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.FirstName)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Last Name</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.LastName)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Email ID</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.EmailID)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>

                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Contact Number</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <div className='customer-contact-fields-div'>
                                                {/* <span>{(singleUserData[0].LastName)}</span> */}
                                                <span>{renderTextWithTooltip(singleUserData[0]?.Phone)}</span>
                                            </div>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Work Address</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.WorkAddress)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zip Code</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.ZipCode)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Date of Birth</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.DOB)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Emergency Contact</label>
                                        <div className='customer-contact-fields-div'>
                                            {/* <span>+91</span> */}
                                            {dataLoading ? (
                                                <Skeleton height={38} />
                                            ) : (
                                                <span>{renderTextWithTooltip(singleUserData[0]?.SecondaryPhone)}</span>)}
                                        </div>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Job Title</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.JobTitle)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label>Roles</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <div>
                                                {/* Join roles in a single line, separated by commas */}
                                                {singleUserData[0]?.UserRoles && singleUserData[0]?.UserRoles.length > 0 ? (
                                                    <span>
                                                        {singleUserData[0]?.UserRoles.map((role, index) => role.RoleName).join(', ')}
                                                    </span>
                                                ) : (
                                                    <span>No roles assigned</span>
                                                )}
                                            </div>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Department</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.DepartmentName)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Joining Date</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.DOJ)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Total Experience DOJ(Years)</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.TotalExperience)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Probation Period (Months)</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.ProbationPeriod)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Home Address</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.HomeAddress)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span>{renderTextWithTooltip(singleUserData[0]?.Status)}</span>)}
                                    </div>
                                    <hr />
                                </Col>
                            </Row>

                            {/* CUSTOM FIELDS DISPLAY */}
                            {getUserCustomFieldData?.length > 0 && (
                                <>
                                    <h6 className="mt-3">Custom Fields</h6>
                                    <Row>
                                        {getUserCustomFieldData.map((field, index) => (
                                            <Col md={4} key={index} className="mb-3">
                                                <div className="view-sla-data">
                                                    <label>{field.CustomFieldLabelName}</label>
                                                    {dataLoading ? (
                                                        <Skeleton height={38} />
                                                    ) : (
                                                        <span>{renderTextWithTooltip(field.CustomFieldValue)}</span>)}
                                                </div>
                                                <hr />
                                            </Col>
                                        ))}
                                    </Row>
                                </>
                            )}


                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal >

            <Modal show={props.viewModal} onHide={props.handleCloseViewModal} className="add-user-submodal">
                <Modal.Header closeButton>
                    <Modal.Title>Set Approval</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {singleUserData[0]?.UserApproval?.length > 0 ? (
                        singleUserData[0].UserApproval.map((approval, index) => {
                            const levelLabel = approvalTypeOptionsOption.find(option => option.value === approval.LevelID)?.label || `Level ${approval.LevelID}`;

                            return (
                                <div key={index} className="customer-form-fields align-items-start">
                                    <div className="view-sla-data">
                                        <label>{approval.ApprovalLevel} Level</label><br />
                                        {dataLoading ? (
                                            <Skeleton height={38} />
                                        ) : (
                                            <span style={{ fontSize: "0.8rem" }}>{levelLabel}</span>)}
                                        <hr />
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p>No approval levels assigned</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ViewUserModal;